module.exports = __webpack_public_path__ + "media/images/proposal/hall-list/proposal-halllist-4-33e66815479ec2cd82544a8ca2bfb95b.png";